import { render, staticRenderFns } from "./_courseId.vue?vue&type=template&id=0cae2f29&"
import script from "./_courseId.vue?vue&type=script&lang=js&"
export * from "./_courseId.vue?vue&type=script&lang=js&"
import style0 from "./_courseId.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./_courseId.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(component)

export default component.exports